// extracted by mini-css-extract-plugin
export default {"frontAndBackAttributeImages":"front-and-back-attribute-images__front-and-back-attribute-images__i2W4Z"};